export function getDemoEnvironment(hostname: string): string | undefined {
	const match = /^www\.(\w+)\.changeeng\.org$/.exec(hostname);
	return (match && match[1]) || undefined;
}
